import React from 'react';
import PropTypes from 'prop-types';

import ContentContainer from 'components/content-container';
import ContactLensHeader from './contact-lens-header';
import MainTitle from 'components/main-title';
import ProductListBlock from 'components/product-list-block';
import ProductDetails from 'components/product-details';

const ContactLensPage = ({
  header,
  productDetails,
  relatedProducts,
  title
}) => (
  <div className="contact-lens-page">
    <ContentContainer>
      <MainTitle title={title} theme={MainTitle.themes.small} />

      <ContactLensHeader {...header} />

      <div className="contact-lens-content">
        {productDetails && (
          <ProductDetails
            className="contact-lens-page__details"
            {...productDetails}
          />
        )}
      </div>

      <div className="contact-lens-blocks">
        {relatedProducts && <ProductListBlock {...relatedProducts} />}
      </div>
    </ContentContainer>
  </div>
);

ContactLensPage.propTypes = {
  header: PropTypes.exact(ContactLensHeader.propTypes),
  productType: PropTypes.string,
  productDetails: PropTypes.exact(ProductDetails.propTypes),
  relatedProducts: PropTypes.exact(ProductListBlock.propTypes),
  title: PropTypes.string
};

export default ContactLensPage;
